var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiTable',{staticClass:"log-table",attrs:{"storage-id":_vm.storageId,"source-columns":_vm.columns,"rows":[].concat( _vm.row ),"is-loading":_vm.isLoading,"pagination":{ show: false },"total":1}})}
var staticRenderFns = []

export { render, staticRenderFns }